"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireDefault(require("../../utils/styled-is"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBText = require("./HBText.styles");
var _mixins = require("../../styles/mixins");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Text = _styledComponents["default"].span.withConfig({
  displayName: "HBText__Text",
  componentId: "sc-1o7bfyi-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return _HBText.textStyles[props.type] || _HBText.newTextStyles[props.type];
}, (0, _styledIs["default"])('$color')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        color: ", ";\n    "])), function (props) {
  return _colors["default"][props.$color];
}), (0, _styledIs["default"])('$fontFamily')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        font-family: ", ";\n    "])), function (props) {
  return props.$fontFamily;
}), (0, _styledIs["default"])('$align')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        text-align: ", ";\n        display: inline-block;\n    "])), function (props) {
  return props.$align;
}), (0, _styledIs["default"])('$weight')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        font-weight: ", ";\n    "])), function (props) {
  return props.$weight;
}), (0, _styledIs["default"])('$italic')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n        font-style: italic;\n    "]))), (0, _styledIs["default"])('$lineThrough')(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n        text-decoration: line-through;\n    "]))), (0, _styledIs["default"])('$margin')(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n        margin: ", ";\n        display: inline-block;\n    "])), function (props) {
  return props.$margin;
}), function (_ref) {
  var $transform = _ref.$transform;
  return $transform && ($transform === 'capitalizeFirstWord' ? (0, _styledComponents.css)(["display:inline-block;&::first-letter{text-transform:capitalize;}"]) : (0, _styledComponents.css)(["text-transform:", ";"], $transform));
}, (0, _styledIs["default"])('$clickable')(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n        cursor: pointer;\n        &:focus-visible {\n            text-decoration: underline;\n        }\n    "]))), function (_ref2) {
  var $ellipsis = _ref2.$ellipsis,
    $lineClamp = _ref2.$lineClamp;
  return $lineClamp > 1 ? (0, _mixins.lineClampedText)($lineClamp) : $ellipsis || $lineClamp === 1 ? _mixins.truncatedText : null;
});

// TODO: handle translation
var HBText = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var align = _ref3.align,
    children = _ref3.children,
    className = _ref3.className,
    _clickable = _ref3.clickable,
    color = _ref3.color,
    _ref3$ellipsis = _ref3.ellipsis,
    ellipsis = _ref3$ellipsis === void 0 ? false : _ref3$ellipsis,
    fontFamily = _ref3.fontFamily,
    italic = _ref3.italic,
    lineClamp = _ref3.lineClamp,
    lineThrough = _ref3.lineThrough,
    margin = _ref3.margin,
    onClick = _ref3.onClick,
    _ref3$tag = _ref3.tag,
    tag = _ref3$tag === void 0 ? 'span' : _ref3$tag,
    testId = _ref3.testId,
    tourId = _ref3.tourId,
    transform = _ref3.transform,
    type = _ref3.type,
    weight = _ref3.weight;
  var clickable = _clickable || !!onClick;
  var handleKeyUp = (0, _react.useCallback)(function (ev) {
    if (clickable && ev.key === 'Enter' && onClick) {
      onClick();
    }
  }, [clickable, onClick]);
  return /*#__PURE__*/_react["default"].createElement(Text, {
    as: tag,
    ref: ref,
    className: className,
    "data-text": typeof children === 'string' ? children : undefined,
    "data-testid": testId,
    "data-tour-id": tourId,
    onClick: onClick,
    onKeyUp: handleKeyUp,
    role: clickable ? 'button' : null,
    tabIndex: clickable ? 0 : null,
    $align: align,
    $clickable: clickable,
    $color: color,
    $ellipsis: ellipsis,
    $italic: italic,
    $lineClamp: lineClamp,
    $transform: transform,
    type: type,
    $weight: weight,
    $fontFamily: fontFamily,
    $lineThrough: lineThrough,
    $margin: margin
  }, children);
});
var _default = exports["default"] = HBText;
//# sourceMappingURL=HBText.js.map